export enum UserRole{
  ADMIN = 'ADMIN',
  USER = 'USER'
}
